import common from "./common.json";
import sys from "./sys.json";
import pos from "./pos.json";
import wallets from "./wallets.json";
import withdrawalOrders from "./withdrawal-orders.json";

export default {
	...common,
	...sys,
	...pos,
	...wallets,
	...withdrawalOrders,
};
